import React, { Component, createRef } from 'react';
import styles from './headerpublicother.module.css';
//import { Link } from 'react-scroll';
import { Link, Events, animateScroll as scroll, scroller } from 'react-scroll'
import { Menu } from 'react-feather';
import { Link as Linkto } from "react-router-dom";
import 'react-sticky-header/styles.css';
//import StickyHeader from 'react-sticky-header';
//import DropDownMenu from "./DropDownMenu";

//function Header() {
class Header extends React.Component {
  navRef = React.createRef();
  constructor(props) {
    super(props);
    this.scrollToTop = this.scrollToTop.bind(this);
    this.state = {
      isMenuOpen: ''
    };
  }

  onScroll = () => {
    if (this.navRef.current) {
      if (window.scrollY > 40) {
        this.navRef.current.classList.add(styles.scrolled);
      } else {
        this.navRef.current.classList.remove(styles.scrolled);
      }
    }
  };

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);

    Events.scrollEvent.register('begin', function () {
      console.log("begin", arguments);
    });
    Events.scrollEvent.register('end', function () {
      console.log("end", arguments);
    });
  }
  scrollToTop() {
    scroll.scrollToTop();
  }
  scrollTo() {
    scroller.scrollTo('scroll-to-element', {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart'
    })
  }
  scrollToWithContainer() {
    let goToContainer = new Promise((resolve, reject) => {
      Events.scrollEvent.register('end', () => {
        resolve();
        Events.scrollEvent.remove('end');
      });
      scroller.scrollTo('scroll-container', {
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart'
      });
    });
    goToContainer.then(() =>
      scroller.scrollTo('scroll-container-second-element', {
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart',
        containerId: 'scroll-container'
      }));
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);

    Events.scrollEvent.remove('begin');
    Events.scrollEvent.remove('end');
  }
  toggleMenu() {
    console.log(222);
    let isOpen = this.state.isMenuOpen;
    if (isOpen === '') {
      isOpen = 'Open';
    } else {
      isOpen = '';
    }
    this.setState({ isMenuOpen: isOpen })
  }
  closeMenu = () => {
    this.setState({ isMenuOpen: '' });
  }
  render() {
    return (<>

      <div ref={this.navRef} className={`${styles.MainNav}`}>
        <div className={(this.state.isMenuOpen === '') ? `${styles.NavInner}` : `${styles.NavInner} ${styles.Open}`}>
          <Linkto to="/" className={`${styles.NavLogo}`}>
            <img src="/static/img/logo.svg" alt="PropertyDek" height="34" />
          </Linkto>
          <div className={`${styles.MobileMenuCustom}`}>
            {/* <ul className={`${styles.NavLinks}`}>
              <li><Link activeClass={`${styles.active}`} to="features" href="" onClick={this.closeMenu}>Features</Link></li>
              <li><Link activeClass={`${styles.active}`} to="platform" href="" onClick={this.closeMenu}>Platform</Link></li>
              <li><Link activeClass={`${styles.active}`} to="why" href="" onClick={this.closeMenu}>Why Us</Link></li>
              <li><Link activeClass={`${styles.active}`} to="ourmission" href="" onClick={this.closeMenu}>Our Mission</Link></li>
            </ul>
            <div className={`${styles.NavActions}`}>
              <Linkto to={'/dashboard/overview'} target="_blank" className={`${styles.SignInBU}`}>Sign In</Linkto>
            </div>*/}
          </div>
          <button className={`${styles.HamburgerMenu}`} onClick={this.toggleMenu.bind(this)}>
            <span></span><span></span><span></span>
          </button>
        </div>
      </div>

    </>);
  }
}
export default Header;